import React, {Component} from 'react';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';
import {
	Button,
	Card,
	CardBody,
	CardImg,
	CardSubtitle,
	CardTitle,
	FormGroup,
	Input,
	InputGroup,
	InputGroupAddon,
	Label,
	Media,
	Modal,
	ModalBody,
	ModalHeader
} from 'reactstrap';
import Apk from '../Apk/Apk';
import AttributesList from '../AttributesList/AttributesList';
import LinkedCompaniesList from '../LinkedCompaniesList/LinkedCompaniesList';
import {fetchCompanies, fetchOperatorTinyCompanies} from '../../actions/companyActions';
import {getRetailAppsList} from '../../actions/retailActions';
import {
	deleteSingleApk,
	deleteSingleApp,
	downloadSingleApk,
	getOneApp,
	getOneAppFromGlobalMarket,
	updateSingleMobileApp
} from '../../actions/marketActions';
import {updateApkAttributes, updateAppAttributes} from '../../actions/attributesActions';
import {API_BASE_URL, COMPANIESMODALVIEWS, GUEST, MARKETVIEW, SUPER_ADMIN} from '../../helpers/constants';
import {I18n} from '../../I18n/components/application';

import './application.css';
import spinner from '../../assets/images/spinner.gif';
import noImg from '../../assets/images/img-error.svg';
import OperatorSelector from "./OperatorSelector";

class Application extends Component {
	constructor(props) {
		super(props);
		this.state = {
			apkModal: false,
			activeApk: null,
			isOkModal: false,
			editable: false,
			attributes: {},
			isApkDownload: {},
			isOkApkModal: false,
			activeApkId: null,
			checkedApks: [],
			oldOperatorId: null,
            activeApp: {
				visibleForCompanies: [],
				operatorId: null
			},
            selectedCompany: '',
            isCompaniesModalShown: false,
            companiesModalView: COMPANIESMODALVIEWS.ADD,
			loading: false,
			activeGlobalApp: null,
			marketingApks: []
		}
	}

	componentDidMount() {
		(async () => {
			this.setState({loading: true});
			const appId = this.props.activeAppId || this.props.match.params.appid;
            await this.props.fetchCompanies(false);
			await this.props.fetchOperatorTinyCompanies();
			const activeApp = await this.props.getOneApp(appId);
			this.setState({
				activeApp: activeApp.data,
				oldOperatorId: activeApp.data.operatorId,
				loading: false
			});
			let activeGlobalApp = await this.props.getOneAppFromGlobalMarket(this.props.activeApp.packageName);
			/* fix for marketing app and apks */
			if (!activeGlobalApp.data || !activeGlobalApp.data.length) {
				const retailMarketItems = await this.props.getRetailAppsList({
					companyId: this.props.company.id,
					mobileAppIds: appId
				});
				if (retailMarketItems.data && retailMarketItems.data.length && retailMarketItems.data[0].mobileApp) {
					activeGlobalApp =  retailMarketItems.data[0].mobileApp;
					console.log(retailMarketItems)
					this.setState({
						marketingApks: retailMarketItems.data[0].marketingApks
							.filter(apk => apk.marketingApkId).map(apk => apk.marketingApkId)
					}, () => {
						console.log(this.state);
					})
				}
			} else {
				activeGlobalApp = activeGlobalApp.data[0];
			}
			/* end of fix*/

			const selectedVersionCodes = this.props.activeApp.apks.reduce((res, apk) => {
				if (!res.includes(apk.versionCode)) {
					res.push(apk.versionCode);
				}
				return res;
			}, []);

			const checkedApks = activeGlobalApp ?
				activeGlobalApp.apks.reduce((res, apk) => {
					if (selectedVersionCodes.includes(apk.versionCode)) {
						res.push(apk.id);
					}
				return res;
			}, []) : [];

			console.log(selectedVersionCodes, checkedApks, activeGlobalApp)
			const apks = activeGlobalApp ?
				activeGlobalApp.apks : []; // fix issue with marketing apps that is not in global market

			const { isApkDownload }  = this.state;
			apks.forEach(apk => {
				isApkDownload[apk.id] = false;
			});
			this.setState({
				isApkDownload,
				checkedApks: checkedApks ? checkedApks : [],//this.props.activeApks ? this.props.activeApks : []
				activeGlobalApp: activeGlobalApp ? activeGlobalApp : null // fix for marketing apks and apps
			});
		})();
	}

	onDownloadApk = (apkId, apkName) => {
		const { isApkDownload } = this.state;
		isApkDownload[apkId] = true;
		this.setState({
			isApkDownload
		});

		this.props.downloadApk(apkId).then( response => {
			const { isApkDownload } = this.state;
			isApkDownload[apkId] = false;
			this.setState({
				isApkDownload
			});
			if (response) {
				const filename = response.fileName;
				const contentType = 'application/apk';

				try {
					const linkElement = document.createElement('a');
					let url = null;
					const blob = new Blob([response.file], {type: contentType});

					if (navigator.msSaveBlob || navigator.msSaveOrOpenBlob) {
						navigator.msSaveOrOpenBlob(blob, filename);
					} else {
						url = window.URL.createObjectURL(blob);
						linkElement.setAttribute('href', url);
						linkElement.setAttribute("download", filename);
					}

					var clickEvent = new MouseEvent("click", {
						"view": window,
						"bubbles": true,
						"cancelable": false
					});

					linkElement.dispatchEvent(clickEvent);
					console.log('success');

				} catch (error) {
					console.error(error);
				}
			}
		}, function(error) {
			console.error(error);
		});
	};

	renderApkList = () => {
		// fix for marketing apks that dont in a global market
		let apks = [];
		let isShowActiveApk = true;
		if (this.state.activeGlobalApp && this.state.activeGlobalApp.apks) {
			apks = this.state.activeGlobalApp.apks;
		}

		// end of fix
		return apks.map(apk => {
			return (
				<li className="apklist__item" key={apk.id}>
					<Card className={this.state.checkedApks.includes(apk.id) && this.props.view == MARKETVIEW.COMPANY_MARKET ? "apk active" : "apk"}>
						<div className="apk__img-wrapper">
							<CardImg top width="10%"
								className="apk__image"
								alt={apk.originalApkFilename}
								src={`${API_BASE_URL}/apps/apks/download/icon/${apk.id}`}
							 	onError={(e) => {
							 		e.target.onerror = null;
							 		e.target.src = noImg
							 	}}
							/>
						</div>
						<CardBody>
							<CardTitle>
								{apk.originalApkFilename}
								<div className="apk-list__statuses">
									<span className={this.state.checkedApks.includes(apk.id) &&
										this.props.view == MARKETVIEW.COMPANY_MARKET ? "apk__active": "invisible"}>
										{I18n[this.props.lang].active}
									</span>
									<span className={this.state.marketingApks.includes(apk.id)
										&& this.props.view == MARKETVIEW.COMPANY_MARKET ? "apk__commercial": "invisible"}>
										{I18n[this.props.lang].commercial}
									</span>
								</div>
							</CardTitle>
							<CardSubtitle className="apk__subtitle">{I18n[this.props.lang].arch} {apk.supportedArchitectures}</CardSubtitle>
							<div className="button-group">
							<Media
								className={!this.state.isApkDownload[apk.id] ?
									'button-group__download visually-hidden' : 'button-group__download'}
								object
								src={spinner}
								alt="Generic placeholder image"
							/>
								<Button
									className={this.state.isApkDownload[apk.id] ?
										'btn apk__download invisible' :
										'btn apk__download visible'}
									color="primary"
									size="sm"
									onClick={() => {this.onDownloadApk(apk.id, apk.originalApkFilename)}}
								>
									{I18n[this.props.lang].download}
								</Button>
								<Button
									className="btn apk__info"
									color="info"
									size="sm"
									onClick={() => {this.toggleApkModal(apk)}}
								>
									{ this.props.authority === SUPER_ADMIN ? `${I18n[this.props.lang].edit}` : `${I18n[this.props.lang].info}` }
								</Button>
								{
									(() => {
										if (this.props.authority === SUPER_ADMIN && this.props.view === MARKETVIEW.GLOBAL_MARKET) {
											return (
												<Button
													color="danger"
													size="sm"
													className="apk-modal__delbtn ml-1"
													onClick={() => {this.isOkApkModalToggle(apk.id)}}>
													{I18n[this.props.lang].delete}
												</Button>
											)
										} else if (this.props.view === MARKETVIEW.COMPANY_MARKET && isShowActiveApk) {
											if (this.state.checkedApks.includes(apk.id) && this.state.checkedApks.length > 1) {
												return (
													<Button
														color="secondary"
														size="sm"
														className="ml-1"
														onClick={() => {
															this.unselectActiveApk(apk.id)
														}}>
														{I18n[this.props.lang].cancelSelection}
													</Button>
												)
											}
											if (!this.state.checkedApks.includes(apk.id) &&
												!this.state.marketingApks.includes(apk.id)) // fix for marketing apks and app
											{
												return (
													<Button
														color="primary"
														size="sm"
														className="ml-1"
														onClick={() => {
															this.selectActiveApk(apk.id)
														}}>
														{I18n[this.props.lang].makeActive}
													</Button>
												)
											}
										}
									})()
								}
							</div>
						</CardBody>
					</Card>
				</li>
			);
		});
	};

	toggleApkModal = app => {
		this.setState({
			apkModal: !this.state.apkModal,
			activeApk: app ? app : null,
		});
	};

	isOkModalToggle = () => {
		this.setState({
			isOkModal: !this.state.isOkModal
		});
	};

	deleteApp = () => {
		this.props.deleteApp(this.props.activeApp.id).then(() => {
			this.isOkModalToggle();
			this.props.changeLocation('/dashboard/market/');
		});
	};

	updateAppAttributesList = attributes => {
		if (attributes) {
			this.props.updateAppAttributes(attributes, this.props.activeApp.id);
		}
		if (this.state.oldOperatorId !== this.state.activeApp.operatorId) {
			const app = Object.assign({}, this.state.activeApp);
			this.props.updateSingleMobileApp(app)
				.then(res => {
					if (res) {
						this.setState({
							activeApp: app,
							selectedCompany: ''
						}, () => {
						})
					}
				});
		}
	};

	updateApkAttributesList = attributes => {
		if (attributes) {
			this.props.updateApkAttributes(attributes, this.props.activeApp.id);
		}
	};

	isOkApkModalToggle = id => {
		this.setState({
			isOkApkModal: !this.state.isOkApkModal,
			activeApkId: id
		});
	};

	deleteApk = () => {
		this.props.deleteApk(this.state.activeApkId).then(() => {
			this.isOkApkModalToggle(null);
			this.props.getOneApp(this.props.activeApp.id);
			this.props.changeLocation(`/dashboard/market/${this.props.activeApp.id}`);
		});
	};

	selectActiveApk = apkId => {
		let checkedApks = this.state.checkedApks;
		const selectedApkPlatform = this.props.singleGlobalMarketApp.apks.filter(apk => apk.id === apkId)[0].supportedArchitectures;
		this.props.singleGlobalMarketApp.apks.forEach(apk => {
			if ( checkedApks.includes(apk.id) && apk.supportedArchitectures === selectedApkPlatform) {
				checkedApks = checkedApks.filter(id => id !== apk.id);
			}
		});
		const updatedApkIds = [...checkedApks, apkId];
		this.props.selectActiveApk(updatedApkIds).then(() => {
			this.setState({
				checkedApks: updatedApkIds
			});
		});
	};

	unselectActiveApk = apkId => {
		const updatedApkIds = this.state.checkedApks.filter(id => id !== apkId);
		this.props.selectActiveApk(updatedApkIds).then(() => {
			this.setState({
				checkedApks: updatedApkIds
			});
		});
	};

    toggleCompaniesModal = () => {
        this.setState(state => ({
            isCompaniesModalShown: !state.isCompaniesModalShown
        }));
    };

    removeVisibleCompanies = company => {
        const app = Object.assign({}, this.state.activeApp);
        app.visibleForCompanies = app.visibleForCompanies.filter(id => id !== company.id);
        this.props.updateSingleMobileApp(app)
            .then(res => {
                if (res) {
                    this.setState({
                        activeApp: app,
                        selectedCompany: ''
                    }, () => {
                    })
                }
            });
    };

    changeCompanyListView = view => {
        this.setState({
            companiesModalView: view
        }, () => {
            this.toggleCompaniesModal();
        });
    };

    isOkRemoveCompanyModalToggle = company => {
        this.setState(state => ({
            isOkRemoveCompanyModal: !state.isOkRemoveCompanyModal,
            selectedCompany: company
        }));
    };

	isMobileAppAttributesChangingAllowed = () => {
		const MobileAppAttributesChangingAttribute = this.props.company.attributes
			.find(attribute => attribute.attribute.label === 'AllowMobileAppAttributesChanging')
		return MobileAppAttributesChangingAttribute.value === 'true' || this.props.authority === SUPER_ADMIN;
	}

	onOperatorsItemChange = operator => {
		const activeApp = {...this.state.activeApp};
		activeApp.operatorId = operator.value;
		this.setState({
			activeApp
		});
	};

    onCompanySelect = event => {
        const value = event.target.value;
        this.setState({
            selectedCompany: value
        })
    };

    onCompanyAdd = () => {
        const app = Object.assign({}, this.state.activeApp);
        app.visibleForCompanies = [...app.visibleForCompanies, +this.state.selectedCompany];
        this.props.updateSingleMobileApp(app)
			.then(res => {
				if (res) {
                    this.setState({
                        activeApp: app,
                        selectedCompany: ''
                    }, () => {
                    })
				}
			});

    };

	renderOperatorSelectorIfAdmin = () => (
        this.props.authority === SUPER_ADMIN
            ? (
                <FormGroup>
                    <Label for="operators">{I18n[this.props.lang].operatorCompany}</Label>
                    <OperatorSelector
                        name="operators"
                        operators={this.props.operatorTinyCompanies}
                        operatorId={this.state.activeApp.operatorId}
                        onOperatorsItemChange={this.onOperatorsItemChange}/>
                </FormGroup>
            )
            : undefined
	);

    renderCompanyVisibility = () => (
		this.props.authority === SUPER_ADMIN ? (
				<FormGroup>
					<Label className="company-list-title">{I18n[this.props.lang].visibility}</Label><br/>
					<Button
						title="Компании"
						type="button"
						onClick={() => {
							this.changeCompanyListView(COMPANIESMODALVIEWS.REMOVE);
						}}
						color="primary"
						size="sm"
						round="true"
						icon="true"
					><i className="fas fa-building"/></Button>
					<InputGroup className="new-attr__custom-select">
						<Input type="select" className="custom-select"
							   value={this.state.selectedCompany}
							   onChange={this.onCompanySelect}
						>
							<option value="">{I18n[this.props.lang].selectCompanyByName}</option>
							{
								this.props.companies.map(company => {
									if (!this.state.activeApp.visibleForCompanies.includes(company.id)) {
										return <option key={company.id}
													   value={company.id}
										>{company.name}</option>
									}
								})
							}
						</Input>
						<InputGroupAddon addonType="prepend">
							<Button
								type="button"
								color="primary"
								onClick={this.onCompanyAdd}
							>{I18n[this.props.lang].addCompany}</Button>
						</InputGroupAddon>
					</InputGroup>
				</FormGroup>
			) : undefined
	);

	render() {
		const { match, isPending, singleGlobalMarketApp, lang, authority } = this.props;
		const {activeApp} = this.state;
		const appImg = `${API_BASE_URL}/apps/mobileapps/download/icon/${activeApp.id}`;
		if (isPending && !singleGlobalMarketApp || this.state.loading) {
			return (
				<div>Loading...</div>
			);
		}
		const attributes = activeApp.mobileAppAttributes ? activeApp.mobileAppAttributes : [];
		return (
			<div>
				<Modal className="del-modal" isOpen={this.state.isOkModal} toggle={this.isOkModalToggle}>
					<ModalHeader>{I18n[lang].modals.sure}</ModalHeader>
					<ModalBody>
						<Button color="danger" className="ml-1" onClick={this.deleteApp}>{I18n[lang].modals.delete}</Button>
						<Button color="secondary" className="ml-1" onClick={this.isOkModalToggle}>{I18n[lang].modals.cancel}</Button>
					</ModalBody>
				</Modal>
				<Modal className="del-modal" isOpen={this.state.isOkApkModal} toggle={this.isOkApkModalToggle}>
					<ModalHeader>{I18n[lang].modals.sure}</ModalHeader>
					<ModalBody>
						<Button color="danger" className="ml-1" onClick={this.deleteApk}>{I18n[lang].modals.delete}</Button>
						<Button color="secondary" className="ml-1" onClick={() => {this.isOkApkModalToggle(null)}}>{I18n[lang].modals.cancel}</Button>
					</ModalBody>
				</Modal>
                <Modal
                    className="companies-modal"
                    isOpen={this.state.isCompaniesModalShown}
                    toggle={this.toggleCompaniesModal}
                >
                    <ModalHeader toggle={this.toggleCompaniesModal}>
                        {this.state.companiesModalView === COMPANIESMODALVIEWS.REMOVE ? `${I18n[lang].modals.companyRemove}` : (
                            this.state.companiesModalView === COMPANIESMODALVIEWS.ADD ? `${I18n[lang].modals.companyAdd}` :
                                this.state.companiesModalView === COMPANIESMODALVIEWS.VIEW ? `${I18n[lang].modals.companiesList}` : ''
                        )}
                    </ModalHeader>
                    <ModalBody>
                        <LinkedCompaniesList
                            companies={this.props.companies}
                            view={this.state.companiesModalView}
                            removeCompanies={this.removeVisibleCompanies}
                            attributeCompanies={this.state.activeApp.visibleForCompanies}
                        />
                    </ModalBody>
                </Modal>
				<Apk
					apkModal={this.state.apkModal}
					apk={this.state.activeApk}
					appId={activeApp.id}
					toggleApkModal={this.toggleApkModal}
					updateApp={() => {this.props.getOneApp(activeApp.id);}}
					attributes={this.state.activeApk && this.state.activeApk.attributes ? this.state.activeApk.attributes : []}
					updateApkAttributesList={this.updateApkAttributesList}
					authority={this.props.authority}
				/>
				<Card className="application">
					<div className="application__top">
						<CardImg
							top
							src={appImg}
							alt="Application image"
						 	onError={(e) => {
							 	e.target.onerror = null;
							 	e.target.src = noImg
						 	}}
						/>
						<section className="application__data">
							<CardTitle>{activeApp.appLabel}</CardTitle>
							<CardSubtitle>{activeApp.packageName}</CardSubtitle>
						</section>
					</div>
					<CardBody>
						{this.renderCompanyVisibility()}
						{this.renderOperatorSelectorIfAdmin()}
					</CardBody>
					<CardBody>
						<CardSubtitle>{I18n[lang].attributes}</CardSubtitle>
						{
							this.props.view == MARKETVIEW.COMPANY_MARKET ? (
								<AttributesList
									attributes={attributes}
									isAttributesChangingAllowed={this.isMobileAppAttributesChangingAllowed()}
									updateAttributesList={this.updateAppAttributesList}
									authority={authority}
									toggleApkModal={this.props.closeModal}
								>
									<CardSubtitle>{I18n[lang].apk}</CardSubtitle>
									<ul className="apklist">
										{this.renderApkList()}
									</ul>
								</AttributesList>
							) : (
								<AttributesList
									attributes={attributes}
									isAttributesChangingAllowed={true}
									updateAttributesList={this.updateAppAttributesList}
									onDeleteApp={this.isOkModalToggle}
									authority={authority}
									toggleApkModal={this.props.closeModal}
								>
									<CardSubtitle>{I18n[lang].apk}</CardSubtitle>
									<ul className="apklist">
										{this.renderApkList()}
									</ul>
								</AttributesList>
							)
						}
					</CardBody>
				</Card>
			</div>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		getOneApp: appId => dispatch(getOneApp(appId)),
        fetchCompanies: query => dispatch(fetchCompanies(query)),
		getOneAppFromGlobalMarket: packageName => dispatch(getOneAppFromGlobalMarket(packageName)),
        getRetailAppsList: query => dispatch(getRetailAppsList(query)),
		deleteApp: appId => dispatch(deleteSingleApp(appId)),
		downloadApk: apkId => dispatch(downloadSingleApk(apkId)),
		changeLocation: url => dispatch(push(url)),
		updateAppAttributes: (attributes, activeAppId) =>
			dispatch(updateAppAttributes(attributes, activeAppId)),
		updateApkAttributes: (attributes, activeAppId) =>
			dispatch(updateApkAttributes(attributes, activeAppId)),
		deleteApk: apkId => dispatch(deleteSingleApk(apkId)),
		updateSingleMobileApp: app => dispatch(updateSingleMobileApp(app)),
		fetchOperatorTinyCompanies: () => dispatch(fetchOperatorTinyCompanies())
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
    companies: state.companiesReducer.companies,
	company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
	activeApp: state.chosenApp,
	singleGlobalMarketApp: state.chosenAppFromGlobalMarket,
    getRetailAppsList: state.retailAppsList.apps,
	isPending: state.requestIsPending,
	authority:  state.currentUser.roles[0].authority || GUEST,
	lang: state.languageReducer.lang,
	operatorTinyCompanies: state.operatorTinyCompaniesReducer.operatorTinyCompanies
});

export default connect(mapStateToProps, mapDispatchToProps)(Application)



// WEBPACK FOOTER //
// ./src/components/Application/Application.js